import {
    InternalEmailLayout,
    dominioIntegrationRow,
    requesterSection
} from "../../email/internal-email-layout";

/**
 * E-mail interno "Solicitação de Feature" — o usuário logado da contabilidade
 * pediu contato para liberar uma funcionalidade fora do contrato.
 *
 * @param {object} params
 * @param {{name, superLogicaId, hubspotId, contract}} params.accounting
 * @param {string} params.feature  funcionalidade solicitada
 * @param {{name, phone, email}} params.requester  usuário logado
 */
export const TemplateFeatureRequest = ({
    accounting = {},
    feature,
    requester = {}
}) =>
    InternalEmailLayout({
        eyebrow: "Solicitação de Feature",
        title: `(${accounting.superLogicaId ?? "-"}) ${accounting.name ?? "-"}`,
        intro: "Um usuário da contabilidade pediu contato para liberar uma funcionalidade.",
        sections: [
            requesterSection(requester),
            {
                title: "Solicitação",
                rows: [["Feature solicitada", feature]]
            },
            {
                title: "Contrato atual",
                rows: [["Plano atual", accounting.contract]]
            },
            {
                title: "Dados da contabilidade",
                rows: [
                    ["Código da Nucont", accounting.superLogicaId],
                    ["Código no HubSpot", accounting.hubspotId],
                    dominioIntegrationRow(accounting.integrationsHealth)
                ]
            }
        ]
    });
